<tec-list-layout>
    <tec-title-group [title]="'DESIGN.TITLE' | translate" [description]="'DESIGN.DESCRIPTION' | translate">
        @if (rolePermissions.canCreateDesignConfig()) {
            <tec-button [label]="'BUTTON.CREATE' | translate" (clickEvent)="goToCreate()"></tec-button>
        }
    </tec-title-group>

    <ng-container content>
        <!-- ERROR  -->
        @if(alertError) {
        <tec-alert status="error" [msg]="alertError" (closeAlert)="alertError = ''" />
        }
        <tec-item-filter>
            <tec-toolbar [toolbar]="toolbar()" [maxFilter]="4" (formFilter)="filterChange($event)" (actionClick)="onToolbarAction($event)" />

            <tec-item-group>
                @if (listLoading) {
                    @for (skeleton of listSkeletonItems; track skeleton) {
                        <tec-item [loading]="true" />
                    }
                } @else if (designList && designList.length > 0) {
                    @for (design of designList; track design.uuid) {
                    <tec-item
                        [tagImage]="{ icon: 'icon-customize', status: 'default' }"
                        [title]="design.title"
                        [detailAction]="design.created_at"
                    >
                        <tec-tag [status]="design.active ? 'success' : 'disabled'">
                            {{ (design.active ? 'DESIGN.ACTIVE' : 'DESIGN.INACTIVE') | translate }}
                        </tec-tag>
                        @if (getCompanyName(design); as companyName) {
                            <tec-list-detail>
                                <span>{{ companyName }}</span>
                            </tec-list-detail>
                        }
                        <tec-link (click)="goToDetail(design.uuid, $event)">{{ 'GENERAL.SHOW_DETAILS' | translate }}</tec-link>
                        @if (rolePermissions.hasPermission(Permission.VIEW_DEVELOPER_ACTION)) {
                            <tec-button-icon
                                icon="icon-code-brackets"
                                type="default"
                                size="sm"
                                [tooltip]="'DESIGN.LIST.CURL_ITEM_TOOLTIP' | translate"
                                (clickEvent)="openDetailCurlModal(design.uuid)"
                            />
                        }
                    </tec-item>
                    }
                    <tec-pagination
                        [pagination]="config.pagination"
                        [elementsByPage]="config.pagination.elementsByPage"
                        [label]="config.pagination.label"
                        (paginationChange)="paginationChange($event)"
                    />
                } @else if (designList?.length === 0) {
                    <tec-empty-state
                        [title]="'DESIGN.NO_RESULTS' | translate"
                        [description]="'DESIGN.NO_RESULTS_DESCRIPTION' | translate"
                        type="notresults"
                    />
                }
            </tec-item-group>
        </tec-item-filter>
    </ng-container>
</tec-list-layout>

@if (showCreateThemeModal()) {
<app-modal-design-theme (closeEvent)="closeCreateThemeModal($event)" />
}

@if (curlModalOpen()) {
<app-modal-curl-request
    [titleKey]="curlModalTitleKey()"
    [curlText]="curlModalText()"
    [showCancelButton]="false"
    (closeEvent)="closeCurlModal()"
/>
}
